// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Treatment/Empty/NewTreatmentModal/Content/query-patient.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice_Treatment_Empty_NewTreatmentModal_Content($id: numeric!) {
  vaxiom_patients_by_pk(id: $id) {
    id
    _id
  }
}

`